// extracted by mini-css-extract-plugin
export var option = "_bi-0";
export var optionCard = "_bi-f";
export var optionContent = "_bi-g";
export var optionIcon = "_bi-i";
export var optionIconBox = "_bi-h";
export var optionLabel = "_bi-j";
export var optionPill = "_bi-m";
export var optionPillBadge = "_bi-p";
export var optionPillIcon = "_bi-n";
export var optionPillLabel = "_bi-o";
export var optionRadio = "_bi-k";
export var optionRadioInner = "_bi-l";
export var optionReveal = "_bi-2";
export var optionRevealDelay0 = "_bi-3";
export var optionRevealDelay1 = "_bi-4";
export var optionRevealDelay10 = "_bi-d";
export var optionRevealDelay11 = "_bi-e";
export var optionRevealDelay2 = "_bi-5";
export var optionRevealDelay3 = "_bi-6";
export var optionRevealDelay4 = "_bi-7";
export var optionRevealDelay5 = "_bi-8";
export var optionRevealDelay6 = "_bi-9";
export var optionRevealDelay7 = "_bi-a";
export var optionRevealDelay8 = "_bi-b";
export var optionRevealDelay9 = "_bi-c";
export var optionSelected = "_bi-1";